import { Toast } from './Toast'

import './index.scss'

export default Toast
export { Toast }
